<div class="layout-col full">
  <span style="width: 95vw"></span>

  <app-number-sequence-detail class="flex" [sequence]="sequence" (closeRequest)="onClose($event)">
  </app-number-sequence-detail>
</div>
